<template>
    <button
      v-if="isButtonVisible"
      class="back-to-top"
      @click="scrollToTop"
      :aria-label="$t('common.backToTop')"
    >
      ↑
    </button>
  </template>
  
  <script>
  export default {
    name: "BackToTopButton",
    data() {
      return {
        isButtonVisible: false
      }
    },
    mounted() {
      // Aggiungiamo il listener allo scroll
      window.addEventListener("scroll", this.handleScroll)
    },
    beforeUnmount() {
      // Rimuoviamo il listener per evitare memory leak
      window.removeEventListener("scroll", this.handleScroll)
    },
    methods: {
      handleScroll() {
        // Threshold per la comparsa del pulsante (es: 300px dall'alto)
        this.isButtonVisible = window.scrollY > 300
      },
      scrollToTop() {
        // scrolla in alto in modo "smooth"
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    }
  }
  </script>
